import * as Icons from 'lucide-react';

interface ToolIconProps {
  icon: any;
  className?: string;
  size?: number;
}

export const ToolIcon = ({ icon, className, size = 24 }: ToolIconProps) => {
  if (!icon) return null;

  if (typeof icon === 'string') {
    const IconComponent = (Icons as any)[icon];
    if (IconComponent) {
      return <IconComponent className={className} size={size} />;
    }
    // Fallback icon if name not found
    const Fallback = Icons.HelpCircle;
    return <Fallback className={className} size={size} />;
  }

  // It is a React component already (legacy icon component)
  const IconComponent = icon;
  return <IconComponent className={className} size={size} />;
};
